import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpDeleteSubgeoParams,
	httpDeleteSubgeo
} from '@/features/subgeo/http/delete-subgeo.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useDeleteSubgeo = (
	urlParams: HttpDeleteSubgeoParams['urlParams'],
	options?: Omit<UseMutationOptions<void, unknown, void>, 'mutationFn'>
) => {
	const queryClient = useQueryClient()

	return useMutation({
		...options,
		mutationFn: () =>
			httpDeleteSubgeo({
				urlParams
			}),
		onError: (error) => {
			errorHandler(error)
		},
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_SUBGEOS]
			})
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.GET_NEIGHBORHOODS]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
